module.exports = __webpack_public_path__ + "img/ic_end_call.d5da0b73.svg";